var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-file-uploader"},[_c('div',{staticClass:"m-3",attrs:{"id":"drag-drop"}})])
}]

export { render, staticRenderFns }